// NOVUS ORDO - Main Application
// Mobile First

// =====================
// ВИСЯЧИЕ ПРЕДЛОГИ (Orphans)
// Автоматически добавляет неразрывный пробел перед короткими словами
// =====================
$(function () {
	// Список предлогов, союзов и частиц, которые не должны висеть в конце строки
	const shortWords = ['а', 'в', 'и', 'к', 'о', 'с', 'у', 'я', 'ж', 'б', 'ли', 'же', 'бы', 'до', 'за', 'из', 'на', 'не', 'ни', 'но', 'об', 'от', 'по', 'то', 'для', 'или', 'под', 'при', 'про', 'что', 'как', 'так', 'чем', 'все', 'это', 'над', 'без'];

	// Регулярное выражение для поиска коротких слов перед пробелом
	const regex = new RegExp('\\s(' + shortWords.join('|') + ')\\s', 'gi');

	function fixOrphans(element) {
		const walker = document.createTreeWalker(
			element,
			NodeFilter.SHOW_TEXT,
			null,
			false
		);

		const textNodes = [];
		while (walker.nextNode()) {
			textNodes.push(walker.currentNode);
		}

		textNodes.forEach(function(node) {
			if (node.nodeValue.trim()) {
				node.nodeValue = node.nodeValue.replace(regex, function(match, word) {
					return ' ' + word + '\u00A0'; // \u00A0 = &nbsp;
				});
			}
		});
	}

	// Применяем ко всему body
	fixOrphans(document.body);
});

// =====================
// ACCORDION - Services
// =====================
$(function () {
	$('.services__item-header').on('click', function () {
		const $header = $(this);
		const $item = $header.closest('.services__item');
		const $allItems = $('.services__item');

		// Закрыть другие
		$allItems.not($item).removeClass('services__item--active');

		// Переключить текущий
		$item.toggleClass('services__item--active');

		// Подскроллить к заголовку, если он ушёл за экран
		setTimeout(function () {
			const headerTop = $header.offset().top;
			const scrollTop = $(window).scrollTop();
			const headerHeight = 80;
			if (headerTop < scrollTop + headerHeight) {
				$('html, body').animate({ scrollTop: headerTop - headerHeight }, 300);
			}
		}, 50);
	});
});

// =====================
// ACCORDION - Industry
// =====================
$(function () {
	$('.industry__item-header').on('click', function () {
		const $header = $(this);
		const $item = $header.closest('.industry__item');
		const $allItems = $('.industry__item');

		// Закрыть другие
		$allItems.not($item).removeClass('industry__item--active');

		// Переключить текущий
		$item.toggleClass('industry__item--active');

		// Подскроллить к заголовку, если он ушёл за экран
		setTimeout(function () {
			const headerTop = $header.offset().top;
			const scrollTop = $(window).scrollTop();
			const headerHeight = 80;
			if (headerTop < scrollTop + headerHeight) {
				$('html, body').animate({ scrollTop: headerTop - headerHeight }, 300);
			}
		}, 50);
	});
});

// =====================
// CALCULATOR
// =====================
$(function () {
	// ===== ДАННЫЕ КАЛЬКУЛЯТОРА =====
	// Читаем из DOM (данные из БД), если нет — используем фоллбэк

	let operationsPrices, taxBasePrices, ownershipExtra, activityColumn, activityFinalMultiplier,
		additionalTaxMultipliers, employeeParams;

	if ($('#calc-data .calc-op').length) {
		// --- Читаем данные из DOM ---

		// Таблица стоимости обработки операций
		operationsPrices = [];
		$('#calc-data .calc-op').each(function () {
			const $el = $(this);
			const maxVal = parseInt($el.data('max'));
			operationsPrices.push({
				max: maxVal === 0 ? Infinity : maxVal,
				prices: [
					parseInt($el.data('services')),
					parseInt($el.data('trade')),
					parseInt($el.data('production'))
				]
			});
		});

		// Базовая стоимость по системе налогообложения
		taxBasePrices = {};
		$('#calc-data .calc-tax').each(function () {
			const $el = $(this);
			const key = $el.data('key');
			const base = parseInt($el.data('base'));
			const ipVal = $el.data('ip');
			if (ipVal !== '' && ipVal !== undefined && ipVal !== null && String(ipVal) !== '0' && String(ipVal) !== '') {
				taxBasePrices[key] = { default: base, ip: parseInt(ipVal) };
			} else {
				taxBasePrices[key] = base;
			}
		});

		// Коэффициенты из DOM, сгруппированные по STR_GROUP
		const coefficients = {};
		$('#calc-data .calc-coeff').each(function () {
			const $el = $(this);
			const group = $el.data('group');
			const key = $el.data('key');
			const value = parseFloat($el.data('value'));
			if (!coefficients[group]) coefficients[group] = {};
			coefficients[group][key] = value;
		});

		ownershipExtra = coefficients.ownership || {};
		activityColumn = {};
		if (coefficients.activity_column) {
			for (const k in coefficients.activity_column) {
				activityColumn[k] = Math.round(coefficients.activity_column[k]);
			}
		}
		activityFinalMultiplier = coefficients.activity_multiplier || {};
		additionalTaxMultipliers = coefficients.additional_tax || {};
		employeeParams = coefficients.employees || {};

	} else {
		// --- Фоллбэк: хардкод (на случай если данных в БД ещё нет) ---

		operationsPrices = [
			{ max: 15, prices: [7000, 9800, 12600] },
			{ max: 30, prices: [14000, 19600, 23800] },
			{ max: 50, prices: [21000, 26600, 35000] },
			{ max: 70, prices: [26600, 35000, 49000] },
			{ max: 100, prices: [33600, 49000, 67200] },
			{ max: 150, prices: [46200, 56000, 88200] },
			{ max: 200, prices: [56000, 63000, 99400] },
			{ max: 300, prices: [77000, 86600, 120400] },
			{ max: 500, prices: [115000, 122000, 145500] },
			{ max: 1000, prices: [150000, 157000, 180500] },
			{ max: Infinity, prices: [200000, 207000, 230500] }
		];

		taxBasePrices = {
			'osno': 14000,
			'usn-d': 12600,
			'usn-dr': 12600,
			'ausn': { default: 5000, ip: 2000 },
			'npd': 2000,
			'osno-zero': 18000,
			'usn-zero': 14400
		};

		ownershipExtra = { 'ooo': 0, 'ip': 0, 'ao': 1000, 'nko': 2000 };

		activityColumn = {
			'services': 0, 'trade': 1, 'jewelry': 1,
			'production': 2, 'marketplace': 1, 'food': 1
		};

		activityFinalMultiplier = {
			'services': 1, 'trade': 1, 'jewelry': 1.3,
			'production': 1, 'marketplace': 1, 'food': 1.2
		};

		additionalTaxMultipliers = { 'patent': 1.1, 'nds': 1.15 };

		employeeParams = { 'ip_discount': -2000, 'extra_above_5': 700, 'foreign_extra': 1000 };
	}

	// Управление видимостью опций в зависимости от выбора
	function updateOptions() {
		const ownership = $('#calc-ownership').val();
		const tax = $('#calc-tax').val();

		// НПД доступен только для ИП
		const $npdOption = $('#calc-tax option[value="npd"]');
		if (ownership !== 'ip') {
			if (tax === 'npd') {
				$('#calc-tax').val('osno');
			}
			$npdOption.prop('disabled', true).hide();
		} else {
			$npdOption.prop('disabled', false).show();
		}

		// Патент доступен только для ИП и не при НПД
		const $patentOption = $('#calc-additional-tax option[value="patent"]');
		if (ownership !== 'ip' || tax === 'npd') {
			if ($('#calc-additional-tax').val() === 'patent') {
				$('#calc-additional-tax').val('none');
			}
			$patentOption.prop('disabled', true).hide();
		} else {
			$patentOption.prop('disabled', false).show();
		}

		// НДС доступен только для УСН (доходы) или УСН (доходы-расходы)
		const $ndsOptions = $('#calc-additional-tax option[value="nds-low"], #calc-additional-tax option[value="nds-full"]');
		if (tax !== 'usn-d' && tax !== 'usn-dr') {
			const currentAdditional = $('#calc-additional-tax').val();
			if (currentAdditional === 'nds-low' || currentAdditional === 'nds-full') {
				$('#calc-additional-tax').val('none');
			}
			$ndsOptions.prop('disabled', true).hide();
		} else {
			$ndsOptions.prop('disabled', false).show();
		}
	}

	function getOperationsPrice(operations, columnIndex) {
		for (let i = 0; i < operationsPrices.length; i++) {
			if (operations <= operationsPrices[i].max) {
				return operationsPrices[i].prices[columnIndex];
			}
		}
		return operationsPrices[operationsPrices.length - 1].prices[columnIndex];
	}

	let currentDisplayedPrice = 0;
	let priceAnimationId = null;

	function animatePrice(targetPrice) {
		if (priceAnimationId) cancelAnimationFrame(priceAnimationId);

		const startPrice = currentDisplayedPrice;
		const diff = targetPrice - startPrice;
		if (diff === 0) return;

		const duration = 400;
		let startTime = null;

		function step(timestamp) {
			if (!startTime) startTime = timestamp;
			const progress = Math.min((timestamp - startTime) / duration, 1);
			// easeOutCubic
			const ease = 1 - Math.pow(1 - progress, 3);
			const current = Math.round(startPrice + diff * ease);
			currentDisplayedPrice = current;

			$('#calc-result-mobile, #calc-result-desktop').text(current.toLocaleString('ru-RU'));

			if (progress < 1) {
				priceAnimationId = requestAnimationFrame(step);
			} else {
				currentDisplayedPrice = targetPrice;
				priceAnimationId = null;
			}
		}

		priceAnimationId = requestAnimationFrame(step);
	}

	function calculatePrice() {
		const ownership = $('#calc-ownership').val();
		const tax = $('#calc-tax').val();
		const additionalTax = $('#calc-additional-tax').val();
		const activity = $('#calc-activity').val();
		const operations = parseInt($('#calc-operations').val()) || 1;
		const employees = parseInt($('#calc-employees').val()) || 1;
		const foreign = parseInt($('#calc-foreign').val()) || 0;

		// ===== 1. ПЕРЕМЕННАЯ ЧАСТЬ: Стоимость обработки документов =====
		const columnIndex = activityColumn[activity];
		let operationsPrice = getOperationsPrice(operations, columnIndex);

		// ===== 2. ПОСТОЯННАЯ ЧАСТЬ: Стоимость отчётов =====

		// 2.1 Базовая стоимость по системе налогообложения
		let taxBasePrice = taxBasePrices[tax];
		if (typeof taxBasePrice === 'object') {
			// АУСН: разная цена для ИП и остальных
			taxBasePrice = ownership === 'ip' ? taxBasePrice.ip : taxBasePrice.default;
		}

		// 2.2 Доплата за форму собственности
		let ownershipPrice = ownershipExtra[ownership] || 0;

		// 2.3 Коэффициент дополнительной системы налогообложения
		let additionalTaxMultiplier = 1;
		if (additionalTax === 'patent') {
			additionalTaxMultiplier = additionalTaxMultipliers.patent || 1.1;
		} else if (additionalTax === 'nds-low' || additionalTax === 'nds-full') {
			additionalTaxMultiplier = additionalTaxMultipliers.nds || 1.15;
		}

		// Применяем коэффициент к базовой стоимости
		let reportsPrice = taxBasePrice * additionalTaxMultiplier + ownershipPrice;

		// 2.4 Сотрудники
		// ИП с 1 сотрудником = ИП без сотрудников
		if (ownership === 'ip' && employees === 1) {
			reportsPrice += (employeeParams.ip_discount || -2000);
		}

		// Доплата за сотрудников свыше 5
		if (employees > 5) {
			reportsPrice += (employees - 5) * (employeeParams.extra_above_5 || 700);
		}

		// Доплата за иностранных сотрудников
		reportsPrice += foreign * (employeeParams.foreign_extra || 1000);

		// ===== 3. ФИНАЛЬНАЯ СТОИМОСТЬ =====
		let totalPrice = operationsPrice + reportsPrice;

		// Применяем финальный коэффициент для вида деятельности
		totalPrice = totalPrice * activityFinalMultiplier[activity];

		// Округляем до целых
		totalPrice = Math.round(totalPrice);

		// Плавная анимация смены цены
		animatePrice(totalPrice);
	}

	// Обновляем опции и цену при изменении формы собственности или системы налогообложения
	$('#calc-ownership, #calc-tax').on('change', function() {
		updateOptions();
		calculatePrice();
	});

	// Обновляем цену при изменении остальных полей
	$('#calc-additional-tax, #calc-activity, #calc-operations').on('change', calculatePrice);

	// Для input полей - обновляем при вводе
	$('#calc-employees, #calc-foreign').on('input change', calculatePrice);

	// Начальная настройка
	updateOptions();
	calculatePrice();

	// Форма отправки заявки
	$('.calculator__form').on('submit', function (e) {
		e.preventDefault();
	});
});

// =====================
// STATISTICS ANIMATION
// =====================
$(function () {
	function animateNumber(element, finalNumber, duration) {
		let startTime = null;

		function step(timestamp) {
			if (!startTime) startTime = timestamp;
			const progress = Math.min((timestamp - startTime) / duration, 1);
			const currentValue = Math.floor(progress * finalNumber);

			element.textContent = currentValue.toLocaleString('ru-RU');

			if (progress < 1) {
				requestAnimationFrame(step);
			} else {
				element.textContent = finalNumber.toLocaleString('ru-RU');
			}
		}

		requestAnimationFrame(step);
	}

	function checkVisibility() {
		$('.statistics__item-number').each(function () {
			const $this = $(this);

			if ($this.data('animated')) return;

			const rect = this.getBoundingClientRect();
			const windowHeight = window.innerHeight;

			if (rect.top >= 0 && rect.bottom <= windowHeight) {
				const text = $this.text().replace(/\D/g, '');
				const finalNumber = parseInt(text, 10);

				if (finalNumber > 0) {
					$this.data('animated', true);
					animateNumber(this, finalNumber, 2000);
				}
			}
		});
	}

	$(window).on('scroll resize', checkVisibility);
	checkVisibility();
});

// =====================
// SMOOTH SCROLL
// =====================
$(function () {
	$('a[href^="#"]').on('click', function (e) {
		const href = $(this).attr('href');

		if (href === '#') return;

		const target = $(href);

		if (target.length) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: target.offset().top - 80
			}, 500);
		}
	});
});

// =====================
// HEADER SCROLL
// =====================
$(function () {
	let lastScroll = 0;

	$(window).on('scroll', function () {
		const currentScroll = $(this).scrollTop();

		if (currentScroll > 50) {
			$('.header').addClass('header--scrolled');
		} else {
			$('.header').removeClass('header--scrolled');
		}

		lastScroll = currentScroll;
	});
});
